import React from 'react';
import useBattlesCollect from 'shared/screens/Battles/hooks/useBattlesCollect';
import styled from 'styled-components';
import { getText, TEXT_KEY } from 'shared/utils/localization';
import BattlesCollectBase from './BattlesCollectBase';

const BattlesCollectGame = props => {
  const data = useBattlesCollect(props);
  return (
    <Wrapper>
      <BattlesCollectBase {...data} />
    </Wrapper>
  );
};

export default BattlesCollectGame;

BattlesCollectGame.title = getText(TEXT_KEY.BATTLES_COLLECT_CONGRATS);
BattlesCollectGame.hideDefaultBackground = false;
BattlesCollectGame.defaultHeader = true;
BattlesCollectGame.AsModalProps = {
  dialogClassName: 'gtp-modal-battles-collect',
};

const Wrapper = styled.main`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
`;

